import React from "react"

export default props => {
  return <input type="file" {...props} />
}
